<template>
    <div class="map-parent">

        <div>
            <div style="display:flex; flex-direction:row;">
                <p style="margin-right:16px;">From</p>
                <input
                    id="startDate"
                    type="date"
                    class="date"
                    v-model="startDate"
                    style="height:25px; width:200px; margin-right:16px;"/>
                <p style="margin-right:16px;">To</p>
                <input
                    id="endDate"
                    type="date"
                    class="date"
                    v-model="endDate"
                    style="height:25px; width:200px; margin-right:16px;"/>
            </div>

            <div style="display:flex; flex-direction:row;">
                <p style="margin-right:16px; margin-bottom:0px;">Employee</p>
                <autocomplete
                    id="employeeSearch"
                    v-model="employeeSearch"
                    :type="28"
                    v-on:finish="setData"
                    style="width:200px; height:30px; margin-right:16px;">
                </autocomplete>
                <button style="height:30px;" v-on:click="search">Display</button>
            </div>
        </div>

        <l-map
        style="width: 100%; height: 100%; margin-top:16px; z-index: 1;"
        :zoom="zoom"
        :center="center">
            <l-marker v-for="marker in markers" :lat-lng="marker.latlng">
                <l-popup class="popup">
                    {{marker.user}}<br>
                    {{marker.timestamp}}<br>
                    {{marker.comments}}
                </l-popup>
            </l-marker>
            <l-polyline  v-for="polyline in polylines" :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
            <l-tile-layer :url="url"></l-tile-layer>
        </l-map>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
import {LMap, LTileLayer, LMarker, LPolyline, LPopup} from 'vue2-leaflet';

export default {
    props: {
		term: ''
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline
    },
	data(){
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 12,
            center: [33.7538924,-118.2421587],
            markers: [/*
                {latlng:[33.749082844568406, -118.26525915802469], user:"Dominik David", comments:"test commenttest commenttest commenttest commenttest commenttest comment", timestamp:"10-10-2021 00:00:00"},
                {latlng:[33.76398993595283, -118.22380742874562], user:"Dominik David", comments:"test commenttest commenttest commenttest commenttest commenttest comment", timestamp:"10-10-2021 00:00:00"}
            */],
            lines: [],
            polylines: [],

            pageid:PAGES.TIMESHEET_MAP_PAGE,
            employeeSearch:"",
            startDate:"",
            endDate:"",
        };
	},
    methods: {
        setPolyLines () {
            this.polylines = []
            for (let i = 0;i < this.lines.length;i++) {
                this.polylines.push({
                    latlngs:[],
                    color: "blue"
                })
                for(let j = 0;j<this.lines[i].length;j++) {
                    this.polylines[i].latlngs.push(this.markers[this.lines[i][j]].latlng)
                }
            }
        },
        search() {
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid,
                        data:[
                            this.employeeSearch,
                            this.startDate,
                            this.endDate,
                        ],
                    }
                }
            ).then((res) => {
                let data = res.data.data.column_data;

                this.markers = []
                this.lines = []

                if(data[0].length==0) {
                    return;
                }

                this.lines.push([])
                for(let i = 0;i<data.length;i++) {
                    let comment = data[i][5] +", "+data[i][6]
                    if(data[i][7]!=-1) comment += ", 11-"+data[i][7]
                    if(data[i][8]!=-1) comment += ", T-"+data[i][8]
                    
                    this.markers.push({
                        latlng: [data[i][2],data[i][3]],
                        user: data[i][4],
                        comments: comment
                    })

                    this.lines[0].push(i)
                }

                this.setPolyLines();
            })
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.setPolyLines();
        })
    }
}
</script>

<style>

.map-parent {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 50px);
    width:100%;
    padding:16px;
}

.popup br {
    margin:5px 0;
}

</style>


// WEBPACK FOOTER //
// src/components/view/Timesheet_Map.vue